<template>
    <div>
        <template v-if="false">
            <LoadCssComponent :estilos="configuracion.css_front"/>
        </template>

        <HeaderComponent/>

        <transition name="fade" mode="out-in">
            <main id="main">
                <router-view/>
            </main>
        </transition>
        <FooterComponent :configuracion="configuracion" :footer="footer" :patrocinadores="patrocinadores"/>
    </div>
</template>

<script setup>
    import { computed, onBeforeMount } from 'vue';
    import store from '@/store';
    import HeaderComponent from '@/components/frontend/header/HeaderComponent';
    import FooterComponent from '@/modules/front/layout/FooterComponent';
    import LoadCssComponent from '@/components/css/LoadCssComponent';
    import { useHead } from '@/composables/common/seo/useHead';

    const configuracion = computed(() => store.getters.getConfig);
    const footer = computed(() => store.getters.getFooter);
    const patrocinadores = computed(() => store.getters.getPatrocinadores);

    onBeforeMount(() => {
        useHead('FrontEnd');
    });
</script>

<style>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
